import { __awaiter, __generator } from "tslib";
import { createSelectDriver, createResponsiveBreadcrumbsDriver } from '../../../drivers';
import { compKey } from './key';
export var createDrillSingleSelectDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    var selectDriver = createSelectDriver(base);
    return {
        getSelectDriver: function () { return selectDriver; },
        hasSelectedBreadcrumbs: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, selectDriver.getSelectedValue()];
                case 1: return [2 /*return*/, (_a.sent()) !== ''];
            }
        }); }); },
        getSelectedValueLabel: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, createResponsiveBreadcrumbsDriver(base)];
        }); }); },
        getCurrentPathBreadcrumbs: function () { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = createResponsiveBreadcrumbsDriver;
                    return [4 /*yield*/, base.$('.select-menu-header')];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
        hasDrillOption: function (index) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, selectDriver.base.$$('.drill-select-item').get(index).$('.menu-drill-button').exists()];
        }); }); },
        isDrillDisabled: function (index) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, selectDriver.base.$$('.drill-select-item').get(index).$('.menu-drill-button').hasClass('disabled')];
        }); }); },
        drillOptionAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, selectDriver.base.$$('.drill-select-item').get(index).$('.menu-drill-button').mouse.press()];
        }); }); },
        hasFilteredResultsNotification: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.results-limit-notification').exists()];
        }); }); },
        hasSearchResultsHeader: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.select-menu-header.search-results-header').exists()];
        }); }); },
        getSearchResultsHeaderText: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.select-menu-header.search-results-header').text()];
        }); }); },
        hasNoSearchResultsMessage: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.no-search-results-message').exists()];
        }); }); },
        hasNoOptionsMessage: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.no-options-message').exists()];
        }); }); },
        openSelection: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, selectDriver.openSelection()];
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map